import { CustomContentDto } from '@app/promotionHub/shared/types/CustomContent';
import { BonusCategoryDto } from '@core/mappers/user/dtos/BalanceDto';
import { BonusTypeComtrade } from '../BonusTypeDto';
import {
    AwardingConditionType,
    TimePeriodType,
} from '@core/models/bonus/AwardingConditions';

export type ComtradeBonusDto = {
    AcceptedDate?: string;
    AwardType: number;
    AwardedDate?: string;
    BonusAmount: number;
    BonusAwarded?: number | null;
    BonusAwarding: BonusAwardingDto;
    BonusBalance: number;
    BonusDescription: string | null;
    BonusFriendlyDescription: string | null;
    BonusFriendlyName: string;
    BonusId: number;
    BonusItemsAwarded: string | null;
    BonusName: string;
    BonusScheduling: BonusSchedulingDto;
    BonusType: BonusTypeComtrade;
    CategoryId?: BonusCategoryDto | null;
    CustomContentList?: CustomContentDto[];
    DeclinedDate: string | null;
    ExpirationDate: string;
    ExternalBonusProductSupplier: string | null;
    ExternalBonusProduct: string | null;
    FreeSpinType: string | null;
    LockedAmount: null;
    LostDate: string | null;
    NumWageredRequirement: number | null;
    NumWageredRequirementLeft: number | null;
    Priority?: number;
    PlayerBonusId: number;
    ProductTypeName: ProductTypeDto;
    PromotionId: number | null;
    RecordCount?: number | null;
    RedeemedDate: string;
    RedeemedAmount: number | null;
    Status: BonusStatusDto;
    TermAndConditionsId: number | null;
    TotalNumWagered: number;
    TotalBonusBets: number;
    TotalWagered: number;
    TotalWageredBonus: number;
    WageringContributionMode: number;
    WageringRequirement: number | null;
    WageringRequirementChunk: WageringRequirementChunkDto;
    WageringRequirementLeft: number | null;
};

export type BonusAwardingDto = {
    AwardConditionFulfilment: AwardConditionFulfilmentItem[];
    AwardConditionFulfilmentOperator: string;
};

type AwardConditionFulfilmentItem = {
    Amount: AmountDto[];
    AwardConditionMet: boolean;
    CurrentDepositNumber: number;
    PaymentMethodIDs: number[];
    PlayerFulfillmentTotal: number;
    PlayerFulfillmentLeft: number;
    TimePeriodType: TimePeriodType;
    TriggerType: AwardingConditionType;
};

type AmountDto = {
    Currency: string;
    Max: number;
    Min: number;
    SequentialNumberOfDeposit: number;
};

type WageringRequirementChunkDto = {
    ChunkType: number;
    ChunkSize: number;
    CurrentChunkFulfilment: number;
    ChunkRedeemAmount: number;
};

type BonusSchedulingDto = {
    BonusCurrentExpiryCondition: string | null;
    BonusCurrentExpiryConditionDate: string | null;
    BonusFixedExpiryDate: string;
    ExpirationDateReal: string | null;
    ExpirationReason: string | null;
    FromDate: string | null;
    TimeToAcceptAwardedBonus: string | null;
    TimeToActivatePendingBonus: string | null;
    TimeToMeetConditionsForWaitingBonus: string | null;
    TimeToRedeemActiveBonus: string | null;
    TimeToStartContributingToWR: string | null;
    TimeToUseFreeSpins: string | null;
    ToDate: string | null;
};

export enum BonusStatusDto {
    Declined = 0,
    Active = 1,
    Pending = 2,
    Expired = 3,
    Lost = 5,
    Redeemed = 6,
    Waiting = 7,
    WaitingManual = 8,
    AwardedExternal= 9,
}

export const ProductTypeDto = {
    Casino: 'Casino',
    Sportsbook: 'Sportsbook',
    Virtuals: 'Virtuals',
    CasinoVirtuals: 'Casino Virtuals', // Golden Race virtuals
} as const;
export type ProductTypeDto = typeof ProductTypeDto[keyof typeof ProductTypeDto];
